<!--
 * @Author: wankong
 * @Desc: 
 * @Date: 2022-01-08 16:27:12
 * @LastEditTime: 2022-01-10 15:53:44
-->
<template>
  <header>
    <div class="left">
      <router-link :to="{ name: 'Home' }"
        ><h2>{{ webInfo.name }}</h2>
      </router-link>
    </div>
    <div class="right">
      <ul>
        <li
          v-for="tab in tabs"
          :key="tab.title"
          @click="jumpTo(tab)"
          :class="currentName == tab.name ? 'active' : ''"
        >
          {{ tab.title }}
        </li>
        <li><router-link :to="{ name: 'Docs' }">文档</router-link></li>
        <li>
          <router-link :to="{ name: 'User' }" v-if="isLogin"
            >个人中心</router-link
          >
          <router-link :to="{ name: 'Login' }" v-else>登录</router-link>
        </li>
      </ul>
    </div>
  </header>
</template>

<script>
export default {
  name: "YKHeader",
  data() {
    return {
      tabs: [
        {
          title: "首页",
          name: "Main",
        },
        {
          title: "产品",
          name: "Product",
        },
        {
          title: "优势",
          name: "Why",
        },
      ],
      currentName: "Main",
    };
  },
  computed: {
    webInfo: function () {
      return this.$store.getters.getWebInfo;
    },
    isLogin: function () {
      return this.$store.getters.getIsLogin;
    },
  },
  methods: {
    jumpTo(id) {
      this.currentName = id.name;
      const currentDom = document.querySelector(`#${id.name}`);
      scrollTo({
        top: currentDom.offsetTop - 60,
        behavior: "smooth",
      });
    },
  },
  mounted() {
    const doms = [
      document.querySelector("#Main"),
      document.querySelector("#Product"),
      document.querySelector("#Why"),
    ];
    window.onscroll = () => {
      doms.forEach((item) => {
        if (item.getClientRects()[0].top < 150) {
          this.currentName = item.id;
          return;
        }
      });
    };
  },
};
</script>

<style lang="less" scoped>
header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 4rem;
  .right {
    li {
      display: inline-block;
      margin: 0 2rem;
      font-size: large;
      cursor: pointer;
    }
  }
}
.active {
  font-weight: 800;
}
</style>
